import {
  authenticatedClient,
  type RequestOptions,
} from "./authenticated-client";
import { productsResponseSchema } from "./schemas";

function getCatalog(options?: RequestOptions) {
  return authenticatedClient
    .get("/v2/products", options)
    .json(productsResponseSchema);
}

function getLibrary(options?: RequestOptions) {
  return authenticatedClient
    .get("/v2/products/library", options)
    .json(productsResponseSchema);
}

const productsApi = { getCatalog, getLibrary };

export { productsApi as ProductsApi };
